module.exports = __webpack_public_path__ + "static/media/fourteenth_the_inn3.3d87e259.png";